import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the updateNode method method.
 */
export function createUpdateNode(context: API.Context) {
  /**
   * Update a node with data.
   */
  return function updateNode(ids: Game.Node.Model, changes: API.UpdateNodeParams): API.Response {
    const { game, respond } = context;

    game.updateNode(changes, ids.move, ids.line);

    return respond(Core.APIEvents.NodeUpdated, {
      changes,
      ids,
      // eslint-disable-next-line no-underscore-dangle
      node: game._getPos(ids.move, ids.line),
    });
  };
}
